import { VueBrowseClasses } from "../../../classes";
import { BrowseStoreState } from "../../../store/types";
import { conditionalField, getApplyButton, getFavoriteButtons, noRows, redirectToViewAll } from "../listBody";
import { JobPosting, JobPostingState, JobPostingStore } from "../types";

export default function setup(dataSource: JobPostingState, state: BrowseStoreState<JobPostingStore, JobPosting>): () => JSX.Element
{
    const getRows = (): JSX.Element[] =>
    {
        if (state.displayRows.length === 0)
        {
            return [noRows()];
        }
        let rows: JSX.Element[] = [];

        for (const displayRow of state.displayRows)
        {
            const jobPosting = displayRow.rowData;
            const jobPostingID = jobPosting.JobPostingID;

            /** These columns have their own custom way of being rendered so we should ignore them when they come up */
            const ignoredColumns: (keyof JobPosting | "")[] = ["", "JobTitle", "IsFavoriteJobPosting", "ApplicationStatus"];
            rows.push(<tr
                ref={(ref: any) => { state.addRowRef(displayRow.rowID, ref as Element) }}
                key={displayRow.rowID}
                class={{
                    [VueBrowseClasses.BodyRow]: true,
                    [VueBrowseClasses.BodyRowSelected]: displayRow.rowID == state.selectedRowID
                }}
                aria-selected={displayRow.rowID == state.selectedRowID}
                onClick={(_event: MouseEvent) => { state.selectRow(displayRow.rowID, true); }}
            >
                <td>
                    <div class="jobPostingMobileTile">
                        <div class="sectionHeader jobPostingSectionHeader" onClick={() => { redirectToViewAll(jobPostingID) }}>
                            <h2 class="sectionHeader__text jobPostingSectionHeaderText jobTitle">
                                {jobPosting.JobTitle}
                            </h2>
                            <div class="featuredJobPostingContainer">
                                <span v-show={jobPosting.IsFeatured} class="featuredJobPostingText">Featured</span>
                            </div>
                        </div>
                        {getFavoriteButtons(dataSource.applicantID, jobPostingID, jobPosting.IsFavoriteJobPosting, dataSource.isPreview)}
                        {
                            displayRow.cells.map(cell =>
                            {
                                if (ignoredColumns.includes(cell.column.fieldName as keyof JobPosting))
                                {
                                    return;
                                }
                                return conditionalField(`${cell.column.displayName}: `, jobPosting[cell.column.fieldName as keyof JobPosting], true, "mobileInfoLine");
                            })
                        }
                        {getApplyButton(jobPostingID, jobPosting.ApplicationStatus, dataSource.isPreview)}
                    </div>
                </td>
            </tr>);
        }
        return rows;
    }

    return () => (
        <tbody class={`jobPostingsMobile ${VueBrowseClasses.TBody}`}>
            {getRows()}
        </tbody>
    );
}
